module.exports = __webpack_public_path__ + "static/media/need-hospital.69eb65d2.jpg";